// 高德地图web服务key
export const MAP_KEY = "67271e82ce85427829dca3b45321f76e";

// 溯源H5解密公匙
export const H5_SECRET_KEY = "SSB2ZbNzdgUzCKnd"

// 接口请求域名配置
// export const BASEURL = "http://192.168.1.95:8080" // 本地测试接口前缀
export const BASEURL = "https://zd.zdagriiot.com/prod-api" // 生产环境接口前缀

// 图片地址配置
// export const IMG_URL = "http://192.168.1.95:8080" // 本地测试图片前缀
export const IMG_URL =  "https://zd.zdagriiot.com/prod-api" // 生产环境图片前缀
